import { useState, useEffect, useContext } from "react";
import {
    Button,
    Grid,
    IconButton
} from "@mui/material";

//Estilo
import "Styles/App.scss"
import UserContextP from "Interfaces/Context";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import axios from "axios";
import Loader from "Components/Loader";
import DialogConfirmation from "Components/DialogConfirmation";
import { CssTextField } from "Components/CssTextField";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from "react-router-dom";
import TableProducts from "Components/DetailDocument/TableProducts";
import Header from "Components/DetailDocument/Header";
import InformationDocument from "Components/DetailDocument/InformationDocument";
// import ClientHistory from "Components/DetailDocument/ClientHistory";

const DetailDocument: React.FC = () => {
    const context = useContext(UserContextP)
    const navigate = useNavigate()
    // Autorizacion de pedidos
    const [loader, setLoader] = useState(false)
    const [order, setOrder] = useState<any>()
    const [showDialog, setshowDialog] = useState(false)
    const [costumer, setCostumer] = useState<any>(null)
    const [message, setMessage] = useState({
        message: "",
        type: "error",
        title: ""
    })
    const [text, setText] = useState("")
    // Obtencion de la data
    // const [listBills, setListBills] = useState<any>([])

    useEffect(() => {
        document.title = "Actualizar estado"
        window?.scrollTo(0, 0);
        setOrder(context?.dataCopy?.order)
        const controller = new AbortController();
        if ( context?.dataCopy?.order === undefined ) {
            navigate(-1)
        } else {
            const signal = controller.signal;
            getInformationCostumer(signal)
            return () => {
                controller.abort();
            }
        }

        //eslint-disable-next-line
    }, [])

    const getInformationCostumer = async (signal: AbortSignal) => {

        console.log('CardCode', context?.dataCopy?.order?.cardCode)
        const response = await axios.get(`${process.env.REACT_APP_URL_ORDER}/api/v1/client`, {
            params: {
                cardCode: context?.dataCopy?.order?.cardCode
            },
            headers: {
                Authorization: `Bearer ${context?.authenticate?.token}`
            },
            signal
        })
        console.log(response.data?.data[0])
        setCostumer(response.data?.data[0] ?? null)
    }

    /// Cambio de estado de la orden, y la guarda en el sistem
    const changeStatusOrder = async (type: boolean) => {
        let data = {
            state: type,
            id: context.dataCopy.order.$key,
            notes: text
        }
        setLoader(true)

        await axios.put(`${process.env.REACT_APP_URL_ORDER}/api/v1/orders/update/status`, data, {
            headers: {
                Authorization: `Bearer ${context.authenticate.token}`
            }
        }).then((response) => {
            setMessage({
                message: response.data?.message ?? 'Orden autorizada correctamente',
                type: 'success',
                title: response.data?.title ??  "Orden creada"
            })
        }).catch((error) => {
            console.log("hereee")
            setMessage({
                message: error.response?.data?.message ?? 'Error al procesar la orden, pueda que el servicio de sincronizacion este abajo. Favor de ponerse en contacto con soporte tecnico.',
                type: error.response?.data?.message?.includes('Orden ya autorizada') ? 'success' : 'error',
                title: "Error"
            })
        }).finally(()=>{
            setLoader(false)
            setshowDialog(true)
        })
    }

    // Cambio de color de fondo
    const assiganteBackgroundColor = (): string => context?.dataCopy?.order?.type && context?.dataCopy?.order?.type === 'PurchaseOrder' ? '#79AC78' : '#173456'

    // Obtiene el listado de facturas
    

    return (
        <>
            <Loader
                openLoader={loader}
                inPage={false}
                redirect={true}
            />
            <DialogConfirmation
                open={showDialog}
                text={message?.message}
                quantity={-1}
                type={message?.type as 'error' | 'success'}
            />
            <div className="App tableUpdateOrder">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <IconButton 
                        onClick={() => navigate(-1)}
                        style={{ 
                            width: "50px",
                            height: "50px",
                            margin:"auto 0",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <ArrowBackIosIcon />
                    </IconButton>
                    <h2>Orden número {order?.numberOrder ?? 0} </h2>
                    <div></div>
                </div>
                {
                        <>
                            <Grid container spacing={1} >
                                <Header
                                    color={assiganteBackgroundColor()}
                                    order={order}
                                    costumer={costumer} />
                                <TableProducts order={order} color={assiganteBackgroundColor()} />
                                <InformationDocument
                                    order={order}
                                    color={assiganteBackgroundColor()} />
                                {/* {
                                    error ?
                                        <Grid item xs={12} style={{ borderTop: '1px solid #CACACA'}}>
                                            <p>No se logro obtener el historial de facturas de este cliente.</p>
                                        </Grid>
                                        :
                                        <ClientHistory
                                            data={listBills}
                                            color={assiganteBackgroundColor()} />
                                } */}


                                <div className="table-details-document">
                                    <div className="thBase thHeader item-cell">
                                        <p style={{ fontSize: "80%", marginTop: "-2px" }}>
                                            Tipo de pago
                                        </p>
                                    </div>
                                    <div className="thBase thHeader item-cell">
                                        <p style={{ fontSize: "80%", marginTop: "-3px" }}>
                                            Tipo de
                                            <br />
                                            contribuyente
                                        </p>
                                    </div>
                                    <div className="thBase thHeader item-cell">
                                        <p style={{ fontSize: "90%", marginTop: "-2px" }}>
                                            {
                                                context?.dataCopy?.order?.type && context?.dataCopy?.order?.type === 'PurchaseOrder' ?
                                                    'Comprador'
                                                    :
                                                    'Vendedor'
                                            }
                                        </p>
                                    </div>
                                    <div className="thBase thContent item-cell">
                                        <h4>
                                            {order?.typePayment}
                                        </h4>
                                    </div>
                                    <div className="thBase thContent item-cell">
                                        <h4 style={{ whiteSpace: "pre-line", overflowWrap: "break-word" }}>
                                            {order?.typeCont}
                                        </h4>
                                    </div>
                                    <div className="thBase thContent item-cell">
                                        <h4>
                                            {order?.vendorName}
                                        </h4>
                                    </div>
                                </div>
                                <Grid item xs={12}>
                                    <CssTextField
                                        label="Comentarios"
                                        rows={4}
                                        multiline
                                        fullWidth
                                        value={order?.comments ?? ''}
                                        disabled
                                        style={{
                                            marginTop: "20px",
                                            marginBottom: "10px"
                                        }}
                                    />

                                    
                                </Grid>
                                <Grid item xs={12}>
                                    <CssTextField
                                        placeholder="Notas para el vendedor"
                                        rows={6}
                                        multiline
                                        fullWidth
                                        value={text}
                                        onChange={(e: any) => {
                                            setText(e.target.value)
                                        }}
                                        style={{
                                            marginTop: "20px",
                                            marginBottom: "10px"
                                        }}
                                    />

                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        size="small"
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        endIcon={<CloseIcon sx={{ marginTop: "-4px" }} />}
                                        style={{
                                            backgroundColor: '#ea3232',
                                        }}
                                        onClick={() => { changeStatusOrder(false) }}
                                    ><p style={{ fontWeight: "600" }}>Rechazar</p></Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color="success"
                                        fullWidth
                                        endIcon={<CheckIcon sx={{ marginTop: "-4px" }} />}
                                        style={{
                                            backgroundColor: '#32d65f',
                                            minHeight: "50px",
                                        }}
                                        onClick={() => {
                                            changeStatusOrder(true)
                                        }}
                                    ><p style={{ fontWeight: "600" }}>Aprobar</p></Button>
                                </Grid>
                            </Grid>
                        </>
                }
            </div>
        </>
    )
}

export default DetailDocument;